// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__EoCHa","logo":"Heading_logo__81YYo","bg":"Heading_bg__1X+PS"};